<div
  *ngIf="!networkDetails"
  class="d-flex justify-content-center align-items-center"
  style="height: 200px"
>
  <p style="margin: 0; font-size: 12px">No Network Details Available</p>
</div>
<mat-accordion *ngIf="networkDetails">
  <mat-expansion-panel expanded>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h3 style="margin: 0">Network Interfaces</h3></mat-panel-title
      >
    </mat-expansion-panel-header>
    <table class="table table-hover">
      <thead>
        <tr class="table-list-head"
          style="
            color: White;
            background-color: var(--s-primary-color);
            height: 2rem;
          "
        >
          <th>Interface</th>
          <th>State</th>
          <th>Address</th>
        </tr>
      </thead>
      <tbody>
        <tr class="table-list-row" *ngFor="let interface of networkDetails.network_interfaces">
          <td class="color-primary">{{ interface.interface }}</td>
          <td>{{ interface.state }}</td>
          <td>{{ interface.address }}</td>
        </tr>
      </tbody>
    </table>
  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h3 style="margin: 0">Routing Table</h3>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <table class="table table-hover">
      <thead>
        <tr class="table-list-head"
          style="
            color: White;
            background-color: var(--s-primary-color);
            height: 2rem;
          "
        >
          <th>Destination</th>
          <th>Gateway</th>
          <th>Interface</th>
        </tr>
      </thead>
      <tbody>
        <tr class="table-list-row" *ngFor="let routing of networkDetails.routing_table">
          <td class="color-primary">{{ routing.destination }}</td>
          <td>{{ routing.gateway }}</td>
          <td>{{ routing.interface }}</td>
        </tr>
      </tbody>
    </table>
  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h3 style="margin: 0">Listening Ports</h3>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <table class="table table-hover">
      <thead>
        <tr class="table-list-head"
          style="
            color: White;
            background-color: var(--s-primary-color);
            height: 2rem;
          "
        >
          <th>Protocol</th>
          <th>Port</th>
        </tr>
      </thead>
      <tbody>
        <tr class="table-list-row" *ngFor="let routing of networkDetails.listening_ports">
          <td class="color-primary">{{ routing.protocol }}</td>
          <td>{{ routing.port }}</td>
        </tr>
      </tbody>
    </table>
  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title
        ><h3 style="margin: 0">Network Traffic</h3>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <table class="table table-hover">
      <thead>
        <tr class="table-list-head"
          style="
            color: White;
            background-color: var(--s-primary-color);
            height: 2rem;
          "
        >
          <th>Interface</th>
          <th>rxkB</th>
          <th>txkB</th>
        </tr>
      </thead>
      <tbody>
        <tr class="table-list-row" *ngFor="let routing of networkDetails.network_traffic">
          <td class="color-primary">
            {{ routing.interface ? routing.interface : "NA" }}
          </td>
          <td>{{ routing.rxkB ? routing.rxkB : "NA" }}</td>
          <td>{{ routing.txkB ? routing.txkB : "NA" }}</td>
        </tr>
      </tbody>
    </table>
  </mat-expansion-panel>
</mat-accordion>
